import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AuditDetailPageComponent } from '@daas-consulting/security/audit/frontend/pages';

@Component({
  selector: 'daas-consulting-production-detail-preview',
  standalone: true,
  templateUrl: './detail_preview.component.html',
  styleUrl: './detail_preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AuditDetailPageComponent,
    CommonModule,
    MatButtonModule,
    MatListModule,
    MatTabsModule,
    MatTooltipModule,
  ],
})
export class DetailPreviewComponent implements AfterContentInit {
  @ViewChild('tabs') tabs!: MatTabGroup;
  @ViewChild('audit') audit!: AuditDetailPageComponent;

  @Output() readonly closePreview: EventEmitter<void> =
    new EventEmitter<void>();
  @Output() readonly editItem: EventEmitter<void> = new EventEmitter<void>();

  @Input() showActionPrimary = false;
  @Input() actionPrimaryName = 'Editar';
  @Input() showAudit = false;
  @Input() title = '';
  @Input() dataTitle = 'Datos';
  @Input() entity = '';
  @Input() entityId = '';

  hasButtons = false;
  hasTitle = false;
  readonly #elementRef: ElementRef;

  constructor(elementRef: ElementRef) {
    this.#elementRef = elementRef;
  }

  ngAfterContentInit(): void {
    this.hasButtons =
      !!this.#elementRef.nativeElement.querySelector('[buttons]');
    this.hasTitle = !!this.#elementRef.nativeElement.querySelector('[title]');
  }

  handleCloseClick($event: MouseEvent): void {
    $event.preventDefault();
    this._close();
    this.closePreview.emit();
  }

  handleEditClick($event: MouseEvent): void {
    $event.preventDefault();
    this._close();
    this.editItem.emit();
  }

  private _close(): void {
    if (this.tabs) {
      this.tabs.selectedIndex = 0;
    }

    if (
      typeof this.showAudit === 'boolean' &&
      this.showAudit &&
      typeof this.audit === 'object' &&
      this.audit !== null
    ) {
      this.audit.reset();
    }
  }
}
